/**
 * @param {number} value
 * @param {number} add
 * @returns {string}
 */
function getValue(value, add = 0) {
  return value + add >= 10 ? `${value + add}` : `0${value + add}`;
}

/**
 * @param {Date} date
 * @param {string} format
 * @returns {number}
 */
function formatDate(date, format) {
  return format
    .replace(/y/g, date.getFullYear())
    .replace(/m/g, getValue(date.getMonth(), 1))
    .replace(/d/g, getValue(date.getDate()))
    .replace(/H/g, getValue(date.getHours()))
    .replace(/M/g, getValue(date.getMinutes()))
    .replace(/S/g, getValue(date.getSeconds()));
}

export default formatDate;
